import type { CatalogTree } from '../types';

export const waiting = {
  count: 'Açık: {count}',
  handoffs: 'Personel bekleyen konuşmalar',
  drafts: 'Onay bekleyen taslaklar',
  empty: 'Bekleyen konuşma yok.',
  draftsEmpty: 'Onay bekleyen taslak yok.',
  wait: '{duration} bekliyor',
  unassigned: 'Sahiplenilmedi',
  claim: 'Sahiplen',
  open: 'Aç',
  resolve: 'Çözüldü',
  returnToAi: 'Asistana geri ver',
  reassign: 'Yeniden ata',
  filters: {
    reason: 'Neden',
    assignee: 'Atanan',
    status: 'Durum',
    all: 'Tümü',
    me: 'Bana atananlar',
    unassigned: 'Atanmamış',
    open: 'Açık',
    claimed: 'Sahiplenildi',
  },
  resolveSheet: {
    title: 'Çözüldü',
    kind: 'Sonuç',
    resolvedByStaff: 'Yanıtlandı',
  },
} as const satisfies CatalogTree;
